// Pilha de janelas abertas: quem está à frente responde ao Esc (e ao F8 de salvar). Sem ela, um Esc com
// dois modais empilhados (o produto e a confirmação de excluir) seria ouvido pelos dois e fecharia os
// dois. É o `useModalStackRegistration` do Desktop, sem Zustand: um contador e o nível de cada modal.
import { useEffect, useMemo, useRef } from 'react';

let abertos = 0;

export interface PilhaModal {
  /**
   * Este modal é o da frente. Função (e não booleano) de propósito: os ouvintes de teclado são
   * registrados uma vez só, e um booleano capturado ficaria congelado no valor do 1º render.
   */
  ehTopo: () => boolean;
}

export function usePilhaModal(): PilhaModal {
  const nivel = useRef(0);
  useEffect(() => {
    abertos += 1;
    nivel.current = abertos;
    return () => {
      abertos = Math.max(0, abertos - 1);
      nivel.current = 0;
    };
  }, []);
  // ">=" e não "===": se um modal de baixo fechar por outro caminho, o total cai e este continua
  // respondendo. Nível 0 (o efeito ainda não rodou) conta como topo, para não ficar surdo ao Esc.
  return useMemo(() => ({ ehTopo: () => nivel.current === 0 || nivel.current >= abertos }), []);
}

/** Há alguma janela aberta (os atalhos da tela por baixo ficam quietos). */
export function haModalAberto(): boolean {
  return abertos > 0;
}
